export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1738669469338-801b4e9dbccf?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  table: "https://images.unsplash.com/photo-1533120921505-7f40f5237ee1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  pizza1: "https://images.unsplash.com/photo-1579751626657-72bc17010498?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  pizza2: "https://images.unsplash.com/photo-1622880833523-7cf1c0bd4296?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  oven: "https://images.unsplash.com/photo-1772758632677-138b22b5d925?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  medFood: "https://images.unsplash.com/photo-1692444866957-12c4c5d7a54e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  edgarPizza: "/edgar-pizza.jpg",
};
